import styled from 'styled-components';

export const StyledValue = styled.span`
  color: ${({ theme }) => theme.colors.transcendNavy3};
`;
